export type ChangePasswordProps = {
  isSuccess?: boolean
  token: string
}
export enum ChangePasswordEnum {
  REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
}
